// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	createContainer,
	type BoundActions,
	type HookFunction,
	type OverrideContainerComponent,
} from '@atlassian/react-sweet-state';
import type { State } from './types.tsx';

const actions = {
	toggleShowQuickstart:
		({ showQuickstartPill }: { showQuickstartPill: boolean }) =>
		({ setState }: { setState: (arg: State) => void }): void => {
			setState({ showQuickstartPill });
		},
};

export type Actions = typeof actions;

const initialState = {
	showQuickstartPill: null,
};

const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'JiraQuickstartPillVisibility',
});

export const QuickstartPillVisibilityContainer: OverrideContainerComponent<unknown> =
	createContainer<State, Actions>(Store, {
		onInit:
			() =>
			({ setState }) => {
				setState({ ...initialState });
			},
	});

export const useQuickstartPillVisibilityStore: HookFunction<
	State,
	BoundActions<
		State,
		{
			toggleShowQuickstart: ({
				showQuickstartPill,
			}: {
				showQuickstartPill: boolean;
			}) => ({ setState }: { setState: (arg: State) => void }) => void;
		}
	>,
	void
> = createHook(Store);
